import { render } from "./Grosir.vue?vue&type=template&id=7fd53ad5&scoped=true"
import script from "./Grosir.vue?vue&type=script&lang=js"
export * from "./Grosir.vue?vue&type=script&lang=js"

import "./Grosir.vue?vue&type=style&index=0&id=7fd53ad5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fd53ad5"]])

export default __exports__